import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveExternalTeacher, resetRetrieveExternalTeacher } from "./retrieve-external-teacher";
import type { ExternalTeacherVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";

const initialState: RetrievalState<Nullable<ExternalTeacherVM>> = { fetching: "idle", data: null };

export const retrieveExternalTeacherReducer = createReducer<RetrievalState<Nullable<ExternalTeacherVM>>>(initialState, builder => {
  builder
    .addCase(retrieveExternalTeacher.fulfilled, (state, { payload }) => {
      return { ...state, data: payload, fetching: "success" };
    })
    .addCase(retrieveExternalTeacher.pending, state => {
      return { ...state, fetching: "pending" };
    })
    .addCase(retrieveExternalTeacher.rejected, state => {
      return { ...state, fetching: "failed" };
    })
    .addCase(resetRetrieveExternalTeacher, () => {
      return initialState;
    });
});
